import { cn } from "@theprelude/core";
import { forwardRef } from "react";

const TBody = forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(function TBody({ className, ...props }, ref) {
  return (
    <tbody ref={ref} className={cn("relative grid", className)} {...props} />
  );
});

const TRow = forwardRef<
  HTMLTableRowElement,
  React.HTMLAttributes<HTMLTableRowElement>
>(function TRow({ className, ...props }, ref) {
  return (
    <tr
      ref={ref}
      className={cn(
        "border-b-secondary-background hover:bg-highlight grid h-[37px] w-full border-b pr-8 leading-5 last-of-type:border-none",
        className,
      )}
      {...props}
    />
  );
});

const TCell = forwardRef<
  HTMLTableCellElement,
  React.TdHTMLAttributes<HTMLTableCellElement>
>(function TCell({ className, ...props }, ref) {
  return (
    <td
      ref={ref}
      className={cn("flex h-full items-center px-2", className)}
      {...props}
    />
  );
});

const THead = forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(function THead({ className, ...props }, ref) {
  return (
    <thead
      ref={ref}
      className={cn(
        "bg-surface-background text-secondary-foreground sticky top-0 z-[1] grid",
        className,
      )}
      {...props}
    />
  );
});

const THeadRow = forwardRef<
  HTMLTableRowElement,
  React.HTMLAttributes<HTMLTableRowElement>
>(function THeadRow({ className, ...props }, ref) {
  return (
    <tr
      ref={ref}
      className={cn("bg-secondary-background grid w-full pr-8", className)}
      {...props}
    />
  );
});

const Table = forwardRef<
  HTMLTableElement,
  React.TableHTMLAttributes<HTMLTableElement>
>(function Table({ className, ...props }, ref) {
  return (
    <table
      ref={ref}
      className={cn(
        "border-secondary-background bg-surface-background grid w-full border-collapse border",
        className,
      )}
      {...props}
    />
  );
});

export { TBody, TRow, TCell, THead, THeadRow, Table };
